import loadScript from "@/utils/loadscript";
import pushGTM from '@/utils/pushGTM'
import { fwgpricecent } from './FilterFwg'
import { readCookie } from '@/app/cookieconsent'
import { config } from '@/config'

export function getGtmConsentCategories() {
  const consentCookie = readCookie(config.CONSENT_COOKIE)
  const consent = consentCookie?.split(/\s*,\s*/)
  const consentCategories = config.CONSENT_CATEGORIES_GTM?.reduce?.((o, c) => {
    o[c] = consent.includes(c) ? 'granted' : 'denied'
    return o
  }, {})

  return consentCategories
}

export async function createAdtTracking({currency, total, number, emailHash, coupon, adtAp, adtTp} = {}) {
	window.ADT = window.ADT || {}
	ADT.Tag = ADT.Tag || {}
	ADT.Tag.t = 3
	ADT.Tag.c = currency
	ADT.Tag.tp = adtTp
	ADT.Tag.am = +total
	ADT.Tag.ti = number
	ADT.Tag.xd = emailHash
	ADT.Tag.cpn = coupon

	await loadScript(`https://cdn.adt361.com/jsTag?ap=${adtAp}`)
}

export async function createGtmTracking({gtmId = '', id, channelName, revenue, tax, shipping, shippingMethod, coupon, couponvalue, brand, zip, products, orderType, emailHash} = {}) {
	let trackedOrders = [];
	if (localStorage && localStorage.fwg_to) {
		try {
			trackedOrders = localStorage.fwg_to.split(',');
		}
		catch(err) {}
	}
	if (trackedOrders.includes(id)) {
		return;
	}

	trackedOrders.push(id);
	localStorage.fwg_to = trackedOrders.slice(-10).join(',');

	pushGTM([
		'config',
		gtmId,
		{
			dimension1: 'Standort',
			dimension2: 'Lieferart',
			dimension3: 'PLZ',
			dimension5: 'Brand',
			dimension6: 'OrderType',
		}
	])

	pushGTM({
    ecommerce: {
        purchase: {
            actionField: {
                id,
                affiliation: channelName,
                revenue,
                tax,
                shipping,
                coupon,
                couponvalue
            },
						products,
        }
    },
    event: "guave.ecommerce",
    Standort: channelName,
    Lieferart: shippingMethod,
    PLZ: zip,
    Brand: brand,
		OrderType: orderType,
    EmailHash: emailHash,
	})
}

export async function gtmUpdateCart({ action, items, channel, currency } = {}) {
	const events = {
		add: 'add_to_cart',
		remove: 'remove_from_cart',
	};

	if (!items.length) {
		return;
	}

	try {
		items = items
			.reduce((all, item) => {
				all.push(item);
				if (item.children?.length) {
					all.push(...item.children);
				}
				return all;
			}, [])
			.map(item => ({
				quantity: 1,
				...item,
			}));

		const gtmData = {
			event: events[action],
			ecommerce: {
				currency: currency || 'CHF',
				value: +fwgpricecent(items.reduce((total, item) => total + (item.quantity * item.price), 0), 'short'),
				items: gtmItems({ items, channel })
			}
		}
		pushGTM(gtmData);
	}
	catch {}

}

function gtmItems({ items, channel } = {}) {
	return items.map(item => ({
		item_id: item.variantCode || item.code,
		item_name: item.name,
		affiliation: channel,
		// TODO: how should taxons be handled?
		// item_category: item.taxons?.[0],
		// item_category2: item.taxons?.[1],
		// item_category3: item.taxons?.[2],
		// item_category4: item.taxons?.[3],
		// item_category5: item.taxons?.[4],
		item_list_name: gtmItemListName(item),
		item_variant: item.variant,
		// location_id: '', // TODO: get google places id in cart.channel.location
		price: +fwgpricecent(item.price, 'short'),
		quantity: item.quantity ?? 1,
	}))
}

function gtmItemListName(item) {
	if (item.isAdditional) {
		return 'Stäbchen & Saucen'
	}

	if (item.isCrossSell) {
		return 'crossselling'
	}

	return null
}

